export default function InputField() {
  return <input type="text" placeholder="This is a text input" />
}
